import { Typography, Box } from "@mui/joy";
import { useMarketContext } from "../../contexts/MarketContext";

const Header = () => {
    const { currentPlan, orgData, isActive } = useMarketContext();

    return (
        <>
            <Typography level="h3" mb={2}>
                Marketplace
            </Typography>

            {orgData.state && currentPlan.state && (
                <Box mb={2}>
                    <Typography level="body-sm">
                        <strong>Pacchetto attivo:</strong>{" "}
                        {currentPlan.state ? currentPlan.state.label : ""}
                    </Typography>
                    <Typography level="body-sm">
                        <strong>Scadenza:</strong>{" "}
                        {new Date(
                            orgData.state ? orgData.state.expiry_date : null
                        ).toLocaleDateString("it-IT")}
                    </Typography>
                    {isActive && (
                        <Typography level="body-sm">
                            <strong>Giorni alla scadenza:</strong>{" "}
                            {Math.ceil(
                                new Date(
                                    orgData.state
                                        ? new Date(
                                              orgData.state.expiry_date
                                          ).getTime() - new Date().getTime()
                                        : null
                                ).getTime() /
                                    (1000 * 60 * 60 * 24)
                            )}
                        </Typography>
                    )}
                </Box>
            )}
        </>
    );
};
export default Header;
